import React, { useState } from 'react'
import { Card, Grid, MenuItem, Select, TextField, Typography } from '@mui/material'

import Button from '../atoms/Button'
import useForm from '../../hooks/useForm'
import useAxios from '../../hooks/useAxios'
import { useParams } from 'react-router-dom'
import { EMAIL } from '../../constants'

const FORM_ENDPOINT = 'api/contact/index.php'

const FormContact = ({ content }) => {
	const { sendMail } = useAxios()
	const [isSubmited, setIsSubmited] = useState(false)
	const { object } = useParams()

	const { handleSubmit, handleChange, data, errors } = useForm({
		validations: {
			name: {
				pattern: {
					value: '^[A-Za-z]*$',
					message: `Oups, le nom n’a pas l’air valide.`,
				},
			},
			email: {
				pattern: {
					value: '^[A-Za-z]*$',
					message: `Oups, l’adresse mail n’a pas l’air valide.`,
				},
			},
			object: {
				pattern: {
					value: '^[A-Za-z]*$',
					message: `Oups, l'objet n'a pas l'air valide`,
				},
			},
			message: {
				required: {
					value: true,
					message: 'Vous ne vouliez pas nous dire quelque chose ?',
				},
				custom: {
					isValid: (value) => value.length < 400,
					message: 'Votre message est trop long',
				},
			},
		},
		onSubmit: () => {
			setIsSubmited(true)
			sendMail(data)
		},
		initialValues: {
			name: '',
		},
	})

	return (
		<Card
			sx={(theme) => ({
				borderRadius: 30,
				bgcolor: 'transparent',
				overflow: 'visible',

				[theme.breakpoints.down('md')]: {
					alignItems: 'baseline',
				},
			})}
		>
			{content}
			<form action={FORM_ENDPOINT} onSubmit={handleSubmit} method="post" target="_blank">
				<Grid
					container
					sx={(theme) => ({
						bgcolor: 'white',
						position: 'absolute',
						width: 486,
						top: 100,
						right: 100,
						justifyContent: 'center',
						boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.25)',
						pt: 10,
						pb: 4,

						px: 4,

						'& fieldset': {
							borderRadius: 0,
						},

						'& .MuiGrid-item': {
							pb: 2,
						},

						borderRadius: 0.3,
						[theme.breakpoints.down('md')]: {
							position: 'relative',
							width: '100%',
							right: 0,
							left: 0,
							m: theme.spacing(2, 'auto'),
							bottom: -10,
						},
					})}
				>
					{(isSubmited && (
						<Grid item xs={12} sx={(theme) => ({ textAlign: 'center' })}>
							<Typography component="h6" sx={{ fontSize: 20, fontWeight: 700, mb: 2 }}>
								Merci pour votre message
							</Typography>
							<Typography component="p" sx={{ fontSize: 18, fontWeight: 400, mb: 3 }}>
								Vous recevrez une réponse dans les prochain jours.
							</Typography>
						</Grid>
					)) || (
						<>
							<Grid item xs={12}>
								<TextField
									color="secondary"
									label="Nom complet"
									required
									variant="outlined"
									value={data.name || ''}
									onChange={handleChange('name')}
									fullWidth
								/>
								{errors.name && (
									<p style={{ color: 'red', fontSize: 10, fontWeight: 400 }}>{errors.name}</p>
								)}
							</Grid>
							<Grid item xs={12}>
								<TextField
									color="secondary"
									label="Adresse email"
									required
									variant="outlined"
									value={data.email || ''}
									onChange={handleChange('email')}
									fullWidth
								/>
								{errors.email && (
									<p style={{ color: 'red', fontSize: 10, fontWeight: 400 }}>{errors.email}</p>
								)}
							</Grid>
							<Grid item xs={12}>
								<Select
									label="Objet"
									value={data.object || object}
									onChange={handleChange('object')}
									color="secondary"
									labelId="select-object"
									id="selectObject"
									name="object"
									defaultValue="Object"
									fullWidth
								>
									<MenuItem value="Object">Object du mail</MenuItem>
									<MenuItem value={EMAIL.DOMICILE}>{EMAIL.DOMICILE}</MenuItem>
									<MenuItem value={EMAIL.ARTISAN}>{EMAIL.ARTISAN}</MenuItem>
									<MenuItem value={EMAIL.SENSIBILISATION}>{EMAIL.SENSIBILISATION}</MenuItem>
									<MenuItem value={EMAIL.BRICOTHEQUE}>{EMAIL.BRICOTHEQUE}</MenuItem>
									<MenuItem value={EMAIL.POSTULER}>{EMAIL.POSTULER}</MenuItem>
									<MenuItem value={EMAIL.BENEVOLE}>{EMAIL.BENEVOLE}</MenuItem>
								</Select>
								{errors.object && (
									<p style={{ color: 'red', fontSize: 10, fontWeight: 400 }}>{errors.email}</p>
								)}
							</Grid>
							<Grid item xs={12}>
								<TextField
									label="Message"
									variant="outlined"
									color="secondary"
									required
									fullWidth
									multiline
									rows={4}
									value={data.message}
									onChange={handleChange('message')}
									placeholder="Posez-nous vos questions ou partagez ici vos réflexion sur le réemploi, sur le fonctionnement de La Collecterie, sur nos ateliers, sur notre chantier d’insertion..."
								/>
								{errors.message && (
									<p style={{ color: 'red', fontSize: 10, fontWeight: 400 }}>{errors.message}</p>
								)}
							</Grid>
							<Grid item xs={12} sx={{ textAlign: 'center' }}>
								<Button type="submit" label="Envoyer votre message" bgColor="blue" color="white" />
							</Grid>
						</>
					)}
				</Grid>
			</form>
		</Card>
	)
}

export default FormContact
